import { Box, Grid2, Typography } from "@mui/material";
import { ImageSection } from "./CourseDetail";
import { Constants, ImagePath, ImageRelativePath, Page_Padding } from "../../shared/constants";
import CustomDivider from "../../shared/utils/CustomDivider";
import TabForPricing from "../../shared/components/Tabs/TabForPricing";
import useTabs from "../../shared/hook/useTabs";
import TabPanel from "../../shared/components/Tabs/TabPanel";
import SubscribedCardTypeSix, { transformSlotData } from "./SubscribedCardTypeSix";
import { useParams } from "react-router-dom";
import { useGetOnlineCourseDetail } from "../../assets/api/useGetApi";
import { useSlotStore } from "../../shared/store/useSlotStore";
import SloteCard from "../../shared/components/SloteCard";
import useResponsive from "../../shared/utils/Responsive";
import useOneToManySlotStore from "../../shared/store/useOneToManySlotStore";

const DetailSection = ({ item }) => {
    const isSmallScreen = useResponsive("sm")
    const { slug } = useParams();
    const { data: CourseDetail, isLoading } = useGetOnlineCourseDetail({ slug: slug })
    const { submittedSlots } = useSlotStore()
    const { oneToManySlot } = useOneToManySlotStore()
    const data = transformSlotData(CourseDetail?.data?.monthly_package?.sessions);

    return (
        <>
            <Grid2 container spacing={5} px={Page_Padding}>
                <Grid2
                    size={{ xs: 12, lg: 7 }}
                    sx={{
                        maxHeight: { xs: 'auto', lg: '70vh' },
                        overflowY: { xs: 'auto', lg: 'scroll' },
                        '&::-webkit-scrollbar': { display: 'none' },
                    }}
                >
                    <Typography variant='body1' mt={1.5}>Description</Typography>
                    <Typography variant='body2' color='grey.400'>
                        {item?.description}

                    </Typography>
                    <CustomDivider />
                    <Typography variant='body2' color='grey.400'>Selected Slots </Typography>

                    {CourseDetail?.data?.online_type === "1tomany" ? <Grid2 container gap="1rem">
                     <Typography variant="body2">{oneToManySlot?.slotname}</Typography>
                        {oneToManySlot?.map((slot, index) => {
                            return (
                                <Grid2 children size={12} key={index}>
                                    <SloteCard key={index} day={slot?.day || ''} start_time={slot?.slottime?.[0]?.start_time} end_time={slot?.slottime?.[0]?.end_time} />
                                </Grid2>
                            );
                        })}
                    </Grid2> :
                        <>

                            {submittedSlots?.map((slot, index) => (
                                <SloteCard key={index} day={data[slot.session_id - 1]?.day || ''} slot={slot} />
                            ))}
                        </>
                    }


                </Grid2>


                <Grid2 size={{ xs: 12, lg: 5 }}>
                    {
                        !isSmallScreen && <SubscribedCardTypeSix item={item} />
                    }
                </Grid2>



            </Grid2>
            {
                isSmallScreen && <SubscribedCardTypeSix item={item} />
            }
        </>
    )
}

const CourseDetailOfTypeSix = () => {
    const { slug } = useParams();
    const { data: CourseDetail, isLoading } = useGetOnlineCourseDetail({ slug: slug })
    const { value, handleChange } = useTabs(0);
    const itemData = [
        { img: `${ImagePath}${ImageRelativePath}${CourseDetail?.data?.cover_image}`, title: 'Image 1' },
        { img: Constants.customImages.CourseDetailFrame2, title: 'Image 2' },
        { img: Constants.customImages.CourseDetailFrame3, title: 'Image 3' }
    ];

    if (isLoading) return
    const tabsData = CourseDetail?.data?.monthly_package?.levels?.map((item) => ({
        label: item?.name,
        component: <DetailSection item={item} />,
    }));
    return (
        <Box className="body course_detail">
            <ImageSection itemData={itemData} isLoading={false} />
            <CustomDivider orientation='horizontal' />
            <Box px={Page_Padding}>

                <Typography variant="h1" component={"h1"}>
                    {CourseDetail?.data?.title}
                </Typography>
                {/* <Typography variant='body2' color='grey.400'>
                        Start Time {getTodayDate()} - End Time {addDaysToToday()}</Typography> */}
                <CustomDivider size={"1rem"} />
                <Typography variant='body1' mt={1.5}>Description</Typography>
                <Typography variant='body2' color='grey.400'>
                    {CourseDetail?.data?.description}

                </Typography>
                <CustomDivider orientation='horizontal' />
                {/* <Typography variant="h1" component={"h1"} style={{ textAlign: "center", mb: 1.5 }}>Description</Typography> */}
                <Typography variant='body1' style={{ textAlign: "center", my: "1rem" }}>
                    Select your preferred grade or level and view available slots before purchase.
                </Typography>
                <CustomDivider orientation='horizontal' size={"1rem"} />
                <TabForPricing tabs={tabsData} value={value} onChange={handleChange} />
            </Box>
            {tabsData?.map((tab, index) => (
                <TabPanel key={index} value={value} index={index}>
                    {tab.component}
                </TabPanel>
            ))}



        </Box>
    )
}

export default CourseDetailOfTypeSix